export const examinationList = [
  {
    value: 1,
    localization: [
      {
        lang: 'en',
        title: 'RX knie (stand, face, profile, schuss) en patella'
      },
      { lang: 'nl', title: 'RX knie (stand, face, profile, schuss) en patella' }
    ]
  },
  {
    value: 2,
    localization: [
      { lang: 'en', title: 'Echografie knie' },
      { lang: 'nl', title: 'Echografie knie' }
    ]
  },
  {
    value: 3,
    localization: [
      { lang: 'en', title: 'RX full leg' },
      { lang: 'nl', title: 'RX full leg' }
    ]
  },
  {
    value: 4,
    localization: [
      { lang: 'en', title: 'CT a blanc knie' },
      { lang: 'nl', title: 'CT a blanc knie' }
    ]
  },
  {
    value: 5,
    localization: [
      { lang: 'en', title: 'ARTRO CT knie' },
      { lang: 'nl', title: 'ARTRO CT knie' }
    ]
  },
  {
    value: 6,
    localization: [
      { lang: 'en', title: 'MRI knie' },
      { lang: 'nl', title: 'MRI knie' }
    ]
  },
  {
    value: 7,
    localization: [
      { lang: 'en', title: 'Botscan 3 fasen' },
      { lang: 'nl', title: 'Botscan 3 fasen' }
    ]
  },
  {
    value: 8,
    localization: [
      { lang: 'en', title: 'Leukocyten scan' },
      { lang: 'nl', title: 'Leukocyten scan' }
    ]
  },
  {
    value: 9,
    localization: [
      { lang: 'en', title: 'SPECT CT' },
      { lang: 'nl', title: 'SPECT CT' }
    ]
  }
];

export const examinationSimpleList = [
  'RX knie (stand, face, profile, schuss) en patella',
  'Echografie knie',
  'RX full leg',
  'CT a blanc knie',
  'ARTRO CT knie',
  'MRI knie',
  'Botscan 3 fasen',
  'Leukocyten scan',
  'SPECT CT'
];

export const sidesList = [
  {
    value: 'Left',
    name: 'left-side',
    label: 'modal_to_radiology_side_left_label'
  },
  {
    value: 'Right',
    name: 'right-side',
    label: 'modal_to_radiology_side_right_label'
  }
];
